<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog  title="Modify Table Tag"
               :visible.sync="tagVisible"
               :close-on-click-modal="false"
               :center="true"
               width="400px"
               size="small"
               @closed ="closeTreeDialog"
               @opened="openAddTree">

      <tree-radio ref="abstractTree"></tree-radio>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="saveTree">Save</el-button>
              <el-button @click="tagVisible = false">close</el-button>
      </span>

    </el-dialog>

    <el-dialog
      title="Edit Table Tag"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="800px"

      size="small"
      @closed ="closeAddDialog"
    >




        <el-form
        label-position="left"
        label-width="120px"
      >
        <el-row>

          <el-form-item  label="DB Url: " required>
            <el-input  v-model="editTableDTO.dbUrl"   size="small"></el-input>
          </el-form-item>

          <el-form-item label="Schema Name: " required>
            <el-input v-model="editTableDTO.schemaName"   size="small"></el-input>
          </el-form-item>


          <el-form-item  label="Table Name: " required>
            <el-input  v-model="editTableDTO.tableName"   size="small"></el-input>
          </el-form-item>

        </el-row>

      </el-form>

      <div style="padding: 10px"> <b>Field& Abstract Tag List </b></div>
      <div class="area">
        <el-form

          label-position="top"  :inline="true"
        >
          <template v-for = "(item, index) in fieldTagList">
            <el-row>
              <el-form-item v-if="index == 0" label="Field Name: " >
                <el-input  v-model="item.fieldName"   size="small"></el-input>
              </el-form-item>
              <el-form-item v-else >
                <el-input  v-model="item.fieldName"   size="small"></el-input>
              </el-form-item>


              <el-form-item   v-if="index == 0" label="Abstract Tag" >
                <el-input v-model="item.tagName"   :disabled="true"  size="small"> </el-input>
              </el-form-item>
              <el-form-item v-else>
                <el-input v-model="item.tagName"   :disabled="true"  size="small"> </el-input>

              </el-form-item>
              <el-form-item >
                <el-button size="small" @click="chooseMyTree(index)" >choose</el-button>
              </el-form-item>



              <el-form-item >
                <el-button size="small" @click="addFieldTagList(index)" >+</el-button>
              </el-form-item>
              <el-form-item v-if ="index != 0 ">
                <el-button size="small" @click="deleteFieldTagList(index)" >-</el-button>
              </el-form-item>
            </el-row>
          </template></el-form>
      </div>





      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="editDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  import treeRadio from '@/view/acs/tree/tree_radio.vue'
  import util from '@/util/util.js'

  export default {
    components: {
      treeRadio
    },
    data(){
      return{
        choosedIndex: -1,
        loadTreeFirstTime:true,
        editDialogVisible: false,
        abstractTreeData:[],
        dataLoading: false,
        editTableDTO:{
          id:'',
          dbUrl:'',
          schemaName:'',
          tableName:''
        },
        fieldTagList:[
          {
            id:'',
            fieldName:'',
            tagId:'',
            tagName:''
          }
        ],
        tagVisible:false,
        abstractKeyData:{},
      }
    },
    computed: {


    },
    created(){


    },


    methods: {
      saveTree(){
        let selectedAbstractTagId = this.$refs.abstractTree.getRadioId();
        // 为了获取abstractKeyData。不一定
        let abstractKeyData = this.getAbstractData();
        if(selectedAbstractTagId){
          let actualData = this.abstractKeyData[selectedAbstractTagId];
          if(actualData){
            this.fieldTagList[this.choosedIndex].tagId = actualData.id;
            this.fieldTagList[this.choosedIndex].tagName = actualData.tagName;
          }

        }
        this.tagVisible = false;

      },
      closeAddDialog(){
        this.editTableDTO = {
          id:'',
          dbUrl:'',
          schemaName:'',
          tableName:''
        };
        this.fieldTagList =[
          {
            id:"",
            fieldName:'',
            tagId:'',
            tagName:''
          }
        ];
      },
      getAbstractKeyData(resultData,childrenData){
        if(childrenData && childrenData.length){
          for(var i in childrenData){
            let itemData = childrenData[i];
            if(itemData.id != 0 ||  !itemData.isService ){
              resultData[itemData.id] = itemData;
              let nextChildrenData = itemData.children;
              this.getAbstractKeyData(resultData,nextChildrenData);

            }
          }
        }
      },

      addFieldTagList(index){
        let fieldTagDO = {
          fieldName:'',
          tagId:'',
          tagName:''
        }
        this.fieldTagList.splice(index + 1,0,fieldTagDO);
      },
      deleteFieldTagList(index){
        this.fieldTagList.splice(index ,1);
      },
      showDialog(row){
        console.log(row);

        this.editTableDTO.id = row.id;
        this.editTableDTO.dbUrl = row.dbUrl;
        this.editTableDTO.schemaName = row.schemaName;
        this.editTableDTO.tableName = row.tableName;

        let children = row.children;
        this.fieldTagList = [];
        if(children && children.length > 0){
          for(let i in children){
            let fieldChild = {};
            fieldChild.id = children[i].id;
            fieldChild.fieldName =children[i].fieldName;
            fieldChild.tagId = children[i].dataAbstractTagId;
            fieldChild.tagName =children[i].tagName;
            this.fieldTagList.push(fieldChild);
          }


        }

        this.editDialogVisible = true;
      },
      hideDialog(){
        this.editDialogVisible = false;
      },

      validateSave() {
        if (this.editTableDTO.id == null || this.editTableDTO.id == '') {
          this.$message.warning("Table Id can not be empty");
          return false;
        }

        if (this.editTableDTO.dbUrl == null || this.editTableDTO.dbUrl == '') {
          this.$message.warning("DB Url can not be empty");
          return false;
        }

        if (this.editTableDTO.schemaName == null || this.editTableDTO.schemaName == '') {
          this.$message.warning("SchemaName can not be empty");
          return false;
        }

        if (this.editTableDTO.tableName == null || this.editTableDTO.tableName == '') {
          this.$message.warning("TableName can not be empty");
          return false;
        }

        let valueList = [];
        for (let i in this.fieldTagList) {
          let itemField = this.fieldTagList[i].fieldName;
          if (!itemField) {
            this.$message.warning("Line " + parseInt(i + 1) + " FieldName can not be empty");
            return false;
          }
          valueList.push(itemField);

        }
        let repeatVal = this.repeatField(valueList);
        if (repeatVal) {
          this.$message.warning("Field  " + repeatVal + "  is duplicate");
          return false;
        }

        return true;

      },
      repeatField(arr){
        var validateObj = {};
        for(var i in arr) {
          if(validateObj[arr[i]]) {
            return arr[i];
          }
          // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
          validateObj[arr[i]] = true;
        }
        return null;
      },

      save(){

        if(this.validateSave()){
          let fieldTagConfigDO = {};
          fieldTagConfigDO.id = this.editTableDTO.id;
          fieldTagConfigDO.dbUrl = this.editTableDTO.dbUrl;
          fieldTagConfigDO.schemaName = this.editTableDTO.schemaName;
          fieldTagConfigDO.tableName = this.editTableDTO.tableName;
          fieldTagConfigDO.fieldList = this.fieldTagList;

          let url = this.baseAcsUrl + '/acs/table-field-tag-config/edit';
          this.http.put(url,fieldTagConfigDO).then(resp =>{
            this.$message.success('Successful operation ');
            this.editDialogVisible = false;
            this.dataLoading = false;
            this.$emit("saveSuccess");
          } ).catch(error => {
            this.dataLoading = false;
            console.info(error);
            this.$emit("saveFail");
             this.$message.warning('Operation failure');
          });
        }

      },
      initAbstractTreeData(treeData){
        this.abstractTreeData = util.deepClone(treeData);
      },
      chooseMyTree(index){
        this.choosedIndex = index;
        this.tagVisible = true;
      },
      closeTreeDialog(){
        this.$refs.abstractTree.setRadioId("");
        this.loadTreeFirstTime = false;
      },
      openAddTree(){
        if(this.loadTreeFirstTime){
          this.$refs.abstractTree.init(this.abstractTreeData,"tagName");
          this.$refs.abstractTree.setRadioId(this.fieldTagList[this.choosedIndex].tagId);
        }else{
          this.$refs.abstractTree.setRadioId(this.fieldTagList[this.choosedIndex].tagId);
        }

      },

      getAbstractData(){
        if(this.abstractKeyData && JSON.stringify(this.abstractKeyData) != '{}'){

        }else{
          let data = {};
          this.getAbstractKeyData(data,this.abstractTreeData);
          this.abstractKeyData = data;
        }
        return this.abstractKeyData;
      },
      setFirstTime(){
        this.loadTreeFirstTime = true;
      }


    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }


  /deep/ .el-collapse-item__content{
    padding-bottom: 10px;
  }


  /deep/ .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-collapse-item__header{
    height: 35px;
    line-height: 35px;
  }

  .area {
    padding: 10px;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    overflow: hidden;
    /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);*/
    font-size: 10px;
  }
  .area .el-form-item{
    margin-left: 20px;
  }

  .el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: bottom;
  }

  .area /deep/ .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
    line-height: 10px;
    margin-top: 10px;
  }


  /deep/ .vxe-table {
    margin: 0px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/table/dialog/edit_table_tag.vue